<!-- Responsibility: Admin SYSTEM tab - Core access and health.
Scope: Status, Flags, Health, and Error Tail. -->
<admin-system-tab>
  <div class="admin-tab-content">
    <div class="admin-grid">
      <admin-access-card
        status-label={ props.state.statusLabel }
        role-label={ props.state.roleLabel }
        uid={ props.state.uid }
        email={ props.state.email }
        source-label={ props.state.sourceLabel }
        flags-saved-label={ props.state.flagsSavedLabel }
        supreme-email={ props.state.supremeEmail }
        access-error={ props.state.accessError }
        on-refresh={ props.onRefresh }
      ></admin-access-card>

      <admin-feature-flags-card
        flags={ props.state.flags }
      ></admin-feature-flags-card>

      <admin-error-tail-card
        error-tail={ props.state.errorTail }
      ></admin-error-tail-card>
    </div>
  </div>

  <script>
    import AdminAccessCard from './admin-access-card.riot'
    import AdminFeatureFlagsCard from './admin-feature-flags-card.riot'
    import AdminErrorTailCard from './admin-error-tail-card.riot'

    export default {
      components: {
        AdminAccessCard, AdminFeatureFlagsCard, AdminErrorTailCard
      }
    }
  </script>

  <style>
    .admin-tab-content { display: grid; gap: var(--space-lg); }
    .admin-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(350px, 1fr)); gap: var(--space-lg); }
  </style>
</admin-system-tab>
